import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";
import { validatePartnershipLegalName } from "../../../../../utils/validators";
import { hexToRGBA } from "../../../../../utils/theme";

import TextInput from "../../../controls/TextInput";

const StyledContainer = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${hexToRGBA("#000000", 0.1)};
`;

const StyledRow = styled(Row)`
  padding: 16px;
`;

function PartnershipInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>Legal information</span>
      </div>
      <StyledRow>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.legalName)}
            label="Name of the Partnership"
            defaultInvalidMessage="Please enter the name of the partnership"
            hint={
              <>
                The only punctuation and special characters allowed are hyphen (-) and ampersand (&). The legal name may
                not contain any of the following endings: Corp, LLC, PLLC, LC, Inc.
              </>
            }
            pattern="(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))(?!.*(?:[ ][iI][nN][cC][oO][rR][pP][oO][rR][aA][tT][eE][dD]$))^[ a-zA-Z0-9&\\-]+$"
            validate={validatePartnershipLegalName}
            value={values[FORM_FIELD_KEYS.legalName]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        </Col>
        <Col xs={12}>
          <TextInput
            {...getFieldProps(FORM_FIELD_KEYS.dbaname)}
            label={getFieldProps(FORM_FIELD_KEYS.dbaname)?.placeholder?.replace("*", "")}
            placeholder={undefined}
            value={values[FORM_FIELD_KEYS.dbaname]}
            onChange={onChange}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            hideDivider
          />
        </Col>
      </StyledRow>
    </StyledContainer>
  );
}

export default PartnershipInfoBlock;
